const areSameGeo = (previousValue, value) => {
    const includeNearbyRegionsMatch = previousValue.searchNearRegions === value.searchNearRegions;
    if (includeNearbyRegionsMatch) {
        const geoLevelsMatch = (level) => {
            const prevLevelId = previousValue.entry[level]?.id;
            const levelId = value.entry[level]?.id;
            const noLevelId = prevLevelId == undefined && levelId == undefined;
            if (noLevelId) {
                return true;
            }
            const bothLevelIds = prevLevelId != undefined && levelId != undefined;
            if (!bothLevelIds) {
                return false;
            }
            else {
                return prevLevelId === levelId;
            }
        };
        const keys = ['region', 'city', 'town', 'zone'];
        for (let index = 0; index < keys.length; index++) {
            const currentKey = keys[index];
            if (!geoLevelsMatch(currentKey)) {
                return false;
            }
        }
        return true;
    }
    else {
        return false;
    }
};

export { areSameGeo as default };
//# sourceMappingURL=areSameGeo.js.map
